import { List, ListItem, Range, Toggle, Stepper } from "konsta/react";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { appSlice } from "../../app/appSlice";

function Home() {
  const poolMode = useAppSelector((state) => state.app.poolMode);
  const spaMode = useAppSelector((state) => state.app.spaMode);
  const poolTemp = useAppSelector((state) => state.app.poolTemp);
  const spaTemp = useAppSelector((state) => state.app.spaTemp);
  const dispatch = useAppDispatch();
  return (
    <div>
      <div className="bg-blue-trim flex flex-row items-stretch justify-center px-3 py-1">
        <div
          className={
            "grow basis-1 h-[72px] " +
            (poolMode
              ? "bg-blue-active text-blue-trim"
              : "bg-blue-disabled text-white") +
            " rounded-lg m-2 p-2"
          }
        >
          <div className="flex flex-row items-center">
            <div className="relative text-blue-trim">
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 32"
                className="w-8 mr-2"
                style={{
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  strokeLinejoin: "round",
                  strokeMiterlimit: "2",
                }}
              >
                <g transform="matrix(1,0,0,1,-24,-140)">
                  <g id="Dashboard-Icons_4">
                    <circle
                      id="Background_15"
                      cx="40"
                      cy="156"
                      r="16"
                      style={{ fill: "currentColor" }}
                    />
                    <g id="Icon-Pool">
                      <path
                        id="swimming-pool"
                        d="M47.332,160.836C46.758,160.726 46.184,160.398 45.719,159.906C45.473,159.66 45.008,159.66 44.762,159.906C44.215,160.48 43.422,160.808 42.629,160.808C41.809,160.808 41.016,160.48 40.469,159.906C40.223,159.66 39.758,159.66 39.512,159.906C38.965,160.48 38.172,160.808 37.379,160.808C36.477,160.808 35.493,160.453 35,159.906C34.754,159.66 34.289,159.66 34.043,159.906C33.524,160.453 33.196,160.726 32.649,160.836C32.293,160.89 32.075,161.219 32.129,161.601C32.184,161.957 32.539,162.176 32.895,162.121C33.606,161.984 34.098,161.656 34.563,161.273C35.328,161.793 36.368,162.121 37.379,162.121C38.336,162.121 39.239,161.82 40.004,161.246C41.481,162.394 43.75,162.394 45.227,161.246C45.801,161.711 46.457,162.011 47.086,162.121L47.223,162.121C47.524,162.121 47.797,161.902 47.852,161.601C47.907,161.219 47.688,160.89 47.332,160.836ZM45.254,149.871C43.805,149.871 42.629,151.074 42.629,152.496L42.629,155.121L36.942,155.121L36.942,152.496C36.942,151.785 37.516,151.183 38.254,151.183C38.965,151.183 39.567,151.785 39.567,152.496L39.567,152.715C39.567,153.097 39.84,153.371 40.223,153.371C40.578,153.371 40.879,153.097 40.879,152.715L40.879,152.496C40.879,151.074 39.676,149.871 38.254,149.871C36.805,149.871 35.629,151.074 35.629,152.496L35.629,158.84C35.629,159.222 35.903,159.496 36.285,159.496C36.641,159.496 36.942,159.222 36.942,158.84L36.942,156.433L42.629,156.433L42.629,158.84C42.629,159.222 42.903,159.496 43.285,159.496C43.641,159.496 43.942,159.222 43.942,158.84L43.942,152.496C43.942,151.785 44.516,151.183 45.254,151.183C45.965,151.183 46.567,151.785 46.567,152.496L46.567,152.715C46.567,153.097 46.84,153.371 47.223,153.371C47.578,153.371 47.879,153.097 47.879,152.715L47.879,152.496C47.879,151.074 46.676,149.871 45.254,149.871Z"
                        style={{ fill: "white", fillRule: "nonzero" }}
                      />
                    </g>
                  </g>
                </g>
              </svg>
              {poolMode ? (
                <div className="absolute translate-y-1/4 right-0 bottom-0 text-blue-trim">
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 20 20"
                    className="w-4"
                    style={{ fillRule: "evenodd", clipRule: "evenodd" }}
                  >
                    <g transform="matrix(1,0,0,1,-44.4384,-160.438)">
                      <g id="Alert-Dot_3">
                        <circle
                          id="Ellipse-4_3"
                          cx="54"
                          cy="170"
                          r="7.5"
                          style={{
                            fill: "rgb(0,171,26)",
                            stroke: "currentColor",
                            strokeWidth: "1px",
                          }}
                        />
                        <path
                          id="check_2"
                          d="M57.555,167.32C57.809,167.555 57.809,167.965 57.555,168.199L52.555,173.199C52.32,173.453 51.91,173.453 51.676,173.199L49.176,170.699C48.922,170.465 48.922,170.055 49.176,169.82C49.41,169.567 49.82,169.567 50.055,169.82L52.106,171.871L56.676,167.32C56.91,167.067 57.32,167.067 57.555,167.32Z"
                          style={{ fill: "white", fillRule: "nonzero" }}
                        />
                      </g>
                    </g>
                  </svg>
                </div>
              ) : null}
            </div>
            POOL TEMP
          </div>
          <div className="text-right">
            {poolMode ? (
              <div>
                {poolTemp}°<span className="text-sm font-bold">F</span>
              </div>
            ) : (
              <div>Pool Off</div>
            )}
          </div>
        </div>
        <div
          className={
            "grow basis-1 h-[72px] " +
            (spaMode
              ? "bg-blue-active text-blue-trim"
              : "bg-blue-disabled text-white") +
            " rounded-lg m-2 p-2"
          }
        >
          <div className="flex flex-row items-center">
            <div className="relative text-blue-trim">
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 32"
                className="w-8 mr-2"
                style={{
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  strokeLinejoin: "round",
                  strokeMiterlimit: "2",
                }}
              >
                <g transform="matrix(1,0,0,1,-200,-140)">
                  <g id="Dashboard-Icons_3">
                    <circle
                      id="Background_6"
                      cx="216"
                      cy="156"
                      r="16"
                      style={{ fill: "currentColor" }}
                    />
                    <g id="Icon-Spa">
                      <path
                        id="spa"
                        d="M223.656,154.25C223.055,154.277 221.332,154.359 219.609,155.234C218.871,153.102 217.723,151.242 216.273,149.984C216.191,149.93 216.082,149.875 216,149.875C215.891,149.875 215.781,149.93 215.699,149.984C214.25,151.242 213.102,153.102 212.363,155.234C210.641,154.359 208.918,154.277 208.316,154.25C208.207,154.25 208.125,154.359 208.125,154.469C208.125,155.234 208.316,157.941 210.531,159.938C212.801,162.125 215.016,162.125 215.918,162.125L216.055,162.125C216.957,162.125 219.199,162.125 221.441,159.938C223.656,157.914 223.848,155.234 223.875,154.469C223.875,154.359 223.766,154.25 223.656,154.25ZM211.461,158.98L211.434,158.953L211.406,158.953C210.258,157.914 209.766,156.629 209.574,155.699C210.641,155.863 212.09,156.328 213.266,157.477L213.266,157.504L213.293,157.504C213.949,158.078 214.414,158.789 214.77,159.637L215.262,160.812C214.332,160.73 212.91,160.402 211.461,158.98ZM216,159.117C215.645,158.27 215.07,157.34 214.168,156.547C213.949,156.328 213.73,156.137 213.512,155.973C214.059,154.223 214.906,152.664 216,151.516C217.066,152.664 217.941,154.223 218.488,155.973C218.242,156.137 218.023,156.328 217.805,156.547C216.902,157.34 216.355,158.27 216,159.117ZM220.566,158.953L220.539,158.953L220.512,158.98C219.062,160.402 217.641,160.73 216.711,160.812L217.203,159.637C217.559,158.789 218.023,158.078 218.68,157.504L218.707,157.504L218.707,157.477C219.883,156.328 221.359,155.863 222.398,155.699C222.207,156.629 221.715,157.914 220.566,158.953Z"
                        style={{ fill: "white", fillRule: "nonzero" }}
                      />
                    </g>
                  </g>
                </g>
              </svg>
              {spaMode ? (
                <div className="absolute translate-y-1/4 right-0 bottom-0 text-blue-trim">
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 20 20"
                    className="w-4"
                    style={{ fillRule: "evenodd", clipRule: "evenodd" }}
                  >
                    <g transform="matrix(1,0,0,1,-44.4384,-160.438)">
                      <g id="Alert-Dot_3">
                        <circle
                          id="Ellipse-4_3"
                          cx="54"
                          cy="170"
                          r="7.5"
                          style={{
                            fill: "rgb(0,171,26)",
                            stroke: "currentColor",
                            strokeWidth: "1px",
                          }}
                        />
                        <path
                          id="check_2"
                          d="M57.555,167.32C57.809,167.555 57.809,167.965 57.555,168.199L52.555,173.199C52.32,173.453 51.91,173.453 51.676,173.199L49.176,170.699C48.922,170.465 48.922,170.055 49.176,169.82C49.41,169.567 49.82,169.567 50.055,169.82L52.106,171.871L56.676,167.32C56.91,167.067 57.32,167.067 57.555,167.32Z"
                          style={{ fill: "white", fillRule: "nonzero" }}
                        />
                      </g>
                    </g>
                  </svg>
                </div>
              ) : null}
            </div>
            SPA TEMP
          </div>
          <div className="text-right">
            {spaMode ? (
              <div>
                {spaTemp}°<span className="text-sm font-bold">F</span>
              </div>
            ) : (
              <div>Spa Off</div>
            )}
          </div>
        </div>
      </div>
      <div className="bg-blue-trim flex flex-row items-stretch justify-center px-3 py-1">
        <div className="grow basis-1 h-[72px] bg-blue-active text-blue-trim rounded-lg m-2 p-2">
          <div className="flex flex-row items-center">
            <div className="relative">
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 32"
                className="w-8 mr-2"
                style={{
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  strokeLinejoin: "round",
                  strokeMiterlimit: "2",
                }}
              >
                <g transform="matrix(1,0,0,1,-24,-220)">
                  <g id="Dashboard-Icons_2">
                    <circle
                      id="Background_4"
                      cx="40"
                      cy="236"
                      r="16"
                      style={{ fill: "currentColor" }}
                    />
                    <g id="Icon-pH">
                      <path
                        id="raindrops"
                        d="M35.242,235.337C34.723,236.212 33.875,237.771 33.875,238.509C33.875,239.548 34.641,240.368 35.625,240.368C36.582,240.368 37.375,239.548 37.375,238.509C37.375,237.771 36.5,236.212 35.981,235.337C35.816,235.063 35.406,235.063 35.242,235.337ZM40,233.259C40,232.521 39.125,230.962 38.606,230.087C38.441,229.813 38.031,229.813 37.867,230.087C37.348,230.962 36.5,232.521 36.5,233.259C36.5,234.298 37.266,235.118 38.25,235.118C39.207,235.118 40,234.298 40,233.259ZM43.008,232.712C42.926,232.575 42.762,232.493 42.625,232.493C42.461,232.493 42.297,232.575 42.215,232.712C41.285,234.052 39.125,237.36 39.125,238.81C39.125,240.642 40.684,242.118 42.625,242.118C44.539,242.118 46.125,240.642 46.125,238.81C46.125,237.36 43.938,234.052 43.008,232.712ZM42.625,240.806C41.395,240.806 40.438,239.903 40.438,238.81C40.438,238.29 41.121,236.759 42.625,234.462C44.102,236.759 44.813,238.29 44.813,238.81C44.813,239.903 43.828,240.806 42.625,240.806Z"
                        style={{ fill: "white", fillRule: "nonzero" }}
                      />
                    </g>
                  </g>
                </g>
              </svg>
              <div className="absolute translate-y-1/4 right-0 bottom-0">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 20 20"
                  className="w-4"
                  style={{ fillRule: "evenodd", clipRule: "evenodd" }}
                >
                  <g transform="matrix(1,0,0,1,-44.4384,-160.438)">
                    <g id="Alert-Dot_3">
                      <circle
                        id="Ellipse-4_3"
                        cx="54"
                        cy="170"
                        r="7.5"
                        style={{
                          fill: "rgb(0,171,26)",
                          stroke: "currentColor",
                          strokeWidth: "1px",
                        }}
                      />
                      <path
                        id="check_2"
                        d="M57.555,167.32C57.809,167.555 57.809,167.965 57.555,168.199L52.555,173.199C52.32,173.453 51.91,173.453 51.676,173.199L49.176,170.699C48.922,170.465 48.922,170.055 49.176,169.82C49.41,169.567 49.82,169.567 50.055,169.82L52.106,171.871L56.676,167.32C56.91,167.067 57.32,167.067 57.555,167.32Z"
                        style={{ fill: "white", fillRule: "nonzero" }}
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            pH
          </div>
          <div className="text-right">7.5</div>
        </div>
        <div className="grow basis-1 h-[72px] bg-blue-active text-blue-trim rounded-lg m-2 p-2">
          <div className="flex flex-row items-center">
            <div className="relative">
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 32"
                className="w-8 mr-2"
                style={{
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  strokeLinejoin: "round",
                  strokeMiterlimit: "2",
                }}
              >
                <g transform="matrix(1,0,0,1,-200,-220)">
                  <g id="Dashboard-Icons">
                    <circle
                      id="Background_2"
                      cx="216"
                      cy="236"
                      r="16"
                      style={{ fill: "currentColor" }}
                    />
                    <g id="Icon-ORP">
                      <path
                        id="vials"
                        d="M222.344,229.869L217.531,229.869C217.148,229.869 216.875,230.17 216.875,230.525C216.875,230.908 217.148,231.181 217.531,231.181L217.75,231.181L217.75,239.849C217.75,240.998 218.57,242.01 219.719,242.119C221.004,242.256 222.125,241.217 222.125,239.931L222.125,231.181L222.344,231.181C222.699,231.181 223,230.908 223,230.525C223,230.17 222.699,229.869 222.344,229.869ZM220.812,235.994L219.062,235.994L219.062,231.181L220.812,231.181L220.812,235.994ZM214.469,229.869L209.656,229.869C209.273,229.869 209,230.17 209,230.525C209,230.908 209.273,231.181 209.656,231.181L209.875,231.181L209.875,239.849C209.875,240.998 210.695,242.01 211.844,242.119C213.129,242.256 214.25,241.217 214.25,239.931L214.25,231.181L214.469,231.181C214.824,231.181 215.125,230.908 215.125,230.525C215.125,230.17 214.824,229.869 214.469,229.869ZM212.938,235.994L211.188,235.994L211.188,231.181L212.938,231.181L212.938,235.994Z"
                        style={{ fill: "white", fillRule: "nonzero" }}
                      />
                    </g>
                  </g>
                </g>
              </svg>
              <div className="absolute translate-y-1/4 right-0 bottom-0">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 20 20"
                  className="w-4"
                  style={{ fillRule: "evenodd", clipRule: "evenodd" }}
                >
                  <g transform="matrix(1,0,0,1,-44.4384,-160.438)">
                    <g id="Alert-Dot_3">
                      <circle
                        id="Ellipse-4_3"
                        cx="54"
                        cy="170"
                        r="7.5"
                        style={{
                          fill: "rgb(0,171,26)",
                          stroke: "currentColor",
                          strokeWidth: "1px",
                        }}
                      />
                      <path
                        id="check_2"
                        d="M57.555,167.32C57.809,167.555 57.809,167.965 57.555,168.199L52.555,173.199C52.32,173.453 51.91,173.453 51.676,173.199L49.176,170.699C48.922,170.465 48.922,170.055 49.176,169.82C49.41,169.567 49.82,169.567 50.055,169.82L52.106,171.871L56.676,167.32C56.91,167.067 57.32,167.067 57.555,167.32Z"
                        style={{ fill: "white", fillRule: "nonzero" }}
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            ORP
          </div>
          <div className="text-right">750mV</div>
        </div>
      </div>
      <List strong>
        <ListItem
          title="Set Temperatures"
          text={"Pool " + poolTemp + "° / Spa " + spaTemp + "°"}
          footer={
            <div className="flex flex-row">
              <Range
                value={poolMode ? poolTemp : spaTemp}
                step={1}
                min={68}
                max={104}
                onChange={(e) => {
                  if (poolMode) {
                    dispatch(
                      appSlice.actions.setPoolTemp(parseInt(e.target.value, 10))
                    );
                  } else {
                    dispatch(
                      appSlice.actions.setSpaTemp(parseInt(e.target.value, 10))
                    );
                  }
                }}
              />
              <Stepper
                className="ml-5"
                value={poolTemp}
                buttonsOnly
                outline
                onPlus={() => {
                  if (poolMode) {
                    if (poolTemp < 104) {
                      dispatch(appSlice.actions.incrementPoolTemp());
                    }
                  } else {
                    if (spaTemp < 104) {
                      dispatch(appSlice.actions.incrementSpaTemp());
                    }
                  }
                }}
                onMinus={() => {
                  if (poolMode) {
                    if (poolTemp > 68) {
                      dispatch(appSlice.actions.decrementPoolTemp());
                    }
                  } else {
                    if (spaTemp > 68) {
                      dispatch(appSlice.actions.decrementSpaTemp());
                    }
                  }
                }}
              />
            </div>
          }
        />
        <ListItem
          label
          title="Pool Mode"
          after={
            <Toggle
              component="div"
              className="-my-1"
              checked={poolMode}
              colors={{ checkedBgIos: "bg-green-toggle" }}
              onChange={() => dispatch(appSlice.actions.togglePoolMode())}
            />
          }
        />
        <ListItem
          label
          title="Spa Mode"
          after={
            <Toggle
              component="div"
              className="-my-1"
              checked={spaMode}
              colors={{ checkedBgIos: "bg-green-toggle" }}
              onChange={() => {
                let newVal = !spaMode;
                dispatch(appSlice.actions.setSpaMode(newVal));
                dispatch(appSlice.actions.setSpaJets(newVal));
                if (newVal) {
                  dispatch(appSlice.actions.setPoolMode(false));
                }
              }}
            />
          }
        />
        <ListItem
          label
          title="Heater"
          after={
            <Toggle
              component="div"
              className="-my-1"
              checked={useAppSelector((state) => state.app.heaterOn)}
              colors={{ checkedBgIos: "bg-green-toggle" }}
              onChange={() => dispatch(appSlice.actions.toggleHeaterOn())}
            />
          }
        />
      </List>
    </div>
  );
}

export default Home;
